import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0164045d")

_pushScopeId("data-v-0164045d")
const _hoisted_1 = {
  key: 0,
  class: "bx bx-sm bxs-folder p-mr-2",
  style: {"color":"var(--folder-color)"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.name == 'FOLDER')
    ? (_openBlock(), _createBlock("i", _hoisted_1))
    : (_openBlock(), _createBlock("span", {
        key: 1,
        class: ["p-text-nowrap p-mr-2 p-px-1 type-tag", {
      [_ctx.normalizedName]: true,
    }]
      }, _toDisplayString(_ctx.$t(`item.type.${_ctx.name}`)), 3))
})